var createReactClass = require('create-react-class');
import React from 'react';

const BanModal = createReactClass({

   render: function() {
    return (
      <div className="reveal-modal middling" id="ban-modal" data-reveal ref="container">
        <div className="modal-body">
          <div className='modal-close'>
            <a href='#' className='cancel-modal'>
              <img src="https://gallery.cureusjournals.com/collection/close_x.png"/>
            </a>
          </div>
          <div className="modal-content middling">
            <h4>Banned User</h4>
            <p>
              <strong>Reason:</strong> {this.props.banReason}
              <br/>
              <strong>Time:</strong> {this.props.banTime}
              <br/>
              <strong>By:</strong> {this.props.banActor}
            </p>
          </div>
        </div>
      </div>
    )
  }
})

export default BanModal;